// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */
.packsContainer_zGDGs {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  background-size: contain;
  align-self: center;
  overflow: hidden;
}
@media (width <= 500px) {
  .packsContainer_zGDGs {
    gap: 50px;
  }
}
.stepsContainer_zbiXz {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.stepContainer_XirgO {
  display: flex;
  flex-direction: column;
  gap: 40px;
  h2,
  h3 {
    margin: 0;
    font-size: clamp(20px, 5vw, 40px);
  }
  h2 {
    font-weight: 300;
  }
  h3 {
    font-weight: 600;
  }
}
.iconContainer_KftvD {
  width: fit-content;

  background-color: var(--_10a37f-background);
  padding: 20px;
  border-radius: 20px 20px 20px 0;
  -webkit-border-radius: 20px 20px 20px 0;
  -moz-border-radius: 20px 20px 20px 0;
  -ms-border-radius: 20px 20px 20px 0;
  -o-border-radius: 20px 20px 20px 0;
}

@media (width <= 680px) {
  .stepsContainer_zbiXz {
    gap: 50px;
    p {
      font-size: 12px;
    }
  }

  .steps_QCc0P {
    width: 145px;
  }
  .iconContainer_KftvD {
    width: 20px;
    .icon_nVyEx {
      width: 20px;
      height: 20px;
    }
  }
}

@media (width <= 500px) {
  .stepsContainer_zbiXz {
    flex-direction: column;
    p {
      font-size: 15px;
    }
  }
  .steps_QCc0P {
    width: 100%;
  }
  .iconContainer_KftvD {
    width: fit-content;
    .icon_nVyEx {
      width: 40px;
      height: 40px;
    }
  }
}
.stepsContent_GrcPV {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

/* .packsDescription {
  color: #676767;
  font-size: clamp(18px, 5vw, 22px); 
  font-weight: 300;
  align-items: center;
  justify-content: center;
  width: 90%;
  text-align: center;
  padding: 0 20px;
  text-align: center;
  p {
    margin: 0;
    line-height: 30px;
  }
  span {
    color: var(--_16c098-color);
    font-weight: 700;
  }
} */

.searchBar_HUB4S {
  display: flex;
  align-items: center;
  width: 728px;
  height: 90px;
  background-color: var(--white-background);
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #ccc;
  margin: 33px 0px;
}

.input_sSXj7 {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 0 17px;
  font-size: 32px;
  font-weight: 400;
  color: var(--_75-color);
}

.button_KPlJU {
  background-color: var(--_16c098-color);
  border: none;
  width: 90px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.button_KPlJU:hover {
  background-color: #13a583;
}






.subtitle_YEu1t {
  color: #676767;
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
}



.logoContainer_w_Rfn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  div {
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    background-color: #16c0981b;
    img {
      width: 80%;
      height: 80%;
      object-fit: contain;
    }
  }
}

.programsContainer_rB63P {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100vh;
}

@media (width <= 500px) {
  .programsContainer_rB63P {
    height: unset;
  }
}

.extensionsTitle_kzv3L {
  font-weight: 700;
  gap: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #1c1e20;
  margin-top: 0px;
  text-align: center;

  h2 {
    margin: 0;
    font-weight: 300;
    font-size: clamp(
      20px,
      5vw,
      40px
    ) !important; 
  }
}





.pdfIcon_jpW70 {
  height: 30px;
  width: 30px;
}


.wrapper_gilUt {
  display: flex;
  justify-content: center;
  gap: 15px;
  text-align: center;
  width: 88%;
  flex-wrap: wrap; 
  align-items: center;
  min-height: fit-content;
}


.card_LqgLz {
  min-width: 280px;
  max-width: 330px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px; 
  align-items: center;
  justify-content: center;
  h4 {
    margin: 3px;
    font-size: 20px;
    font-weight: 400;
    color: #1C1E20;
    span{
      font-weight: 600;
    }
  }
}
.greenWordDescription_bc16V{
  color: #10A37F;
}
@media (width <= 660px) {
  .stepsContent_GrcPV {
    flex-direction: column;
    align-items: center;
  }
}
.card_LqgLz:nth-child(3) {
  max-width: clamp(210px, 32%, 300px); 
}

.step_kbeb_ {
  color: #16c098 !important;
  font-size: clamp(16px, 4vw, 22px); 
  font-weight: 400;
  color: #18181b;
  font-size: clamp(15px, 5vw, 19px); 
  margin: 20px 0;
}

.subtitle_YEu1t {
  color: var(--_71717a-color);
  font-size: clamp(
    16px,
    4vw,
    20px
  ); 
  font-weight: 300;
  line-height: 1.5;
  margin: 0;
}

`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Packs/Packs.module.css"],"names":[],"mappings":"AAAA,qGAAqG;AACrG;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;;IAEE,SAAS;IACT,iCAAiC;EACnC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;;EAElB,2CAA2C;EAC3C,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;IACE,SAAS;IACT;MACE,eAAe;IACjB;EACF;;EAEA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;;;;;AAOA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B;MACE,UAAU;MACV,WAAW;MACX,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,kBAAkB;;EAElB;IACE,SAAS;IACT,gBAAgB;IAChB;;;;gBAIY;EACd;AACF;;;;;;AAMA;EACE,YAAY;EACZ,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd;MACE,gBAAgB;IAClB;EACF;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B;;;;GAIC;EACD,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\"); */\n.packsContainer {\n  display: flex;\n  width: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  font-family: \"Inter\", sans-serif;\n  background-size: contain;\n  align-self: center;\n  overflow: hidden;\n}\n@media (width <= 500px) {\n  .packsContainer {\n    gap: 50px;\n  }\n}\n.stepsContainer {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.stepContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  h2,\n  h3 {\n    margin: 0;\n    font-size: clamp(20px, 5vw, 40px);\n  }\n  h2 {\n    font-weight: 300;\n  }\n  h3 {\n    font-weight: 600;\n  }\n}\n.iconContainer {\n  width: fit-content;\n\n  background-color: var(--_10a37f-background);\n  padding: 20px;\n  border-radius: 20px 20px 20px 0;\n  -webkit-border-radius: 20px 20px 20px 0;\n  -moz-border-radius: 20px 20px 20px 0;\n  -ms-border-radius: 20px 20px 20px 0;\n  -o-border-radius: 20px 20px 20px 0;\n}\n\n@media (width <= 680px) {\n  .stepsContainer {\n    gap: 50px;\n    p {\n      font-size: 12px;\n    }\n  }\n\n  .steps {\n    width: 145px;\n  }\n  .iconContainer {\n    width: 20px;\n    .icon {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n@media (width <= 500px) {\n  .stepsContainer {\n    flex-direction: column;\n    p {\n      font-size: 15px;\n    }\n  }\n  .steps {\n    width: 100%;\n  }\n  .iconContainer {\n    width: fit-content;\n    .icon {\n      width: 40px;\n      height: 40px;\n    }\n  }\n}\n.stepsContent {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  flex-wrap: wrap;\n}\n\n/* .packsDescription {\n  color: #676767;\n  font-size: clamp(18px, 5vw, 22px); \n  font-weight: 300;\n  align-items: center;\n  justify-content: center;\n  width: 90%;\n  text-align: center;\n  padding: 0 20px;\n  text-align: center;\n  p {\n    margin: 0;\n    line-height: 30px;\n  }\n  span {\n    color: var(--_16c098-color);\n    font-weight: 700;\n  }\n} */\n\n.searchBar {\n  display: flex;\n  align-items: center;\n  width: 728px;\n  height: 90px;\n  background-color: var(--white-background);\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid #ccc;\n  margin: 33px 0px;\n}\n\n.input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 0 17px;\n  font-size: 32px;\n  font-weight: 400;\n  color: var(--_75-color);\n}\n\n.button {\n  background-color: var(--_16c098-color);\n  border: none;\n  width: 90px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.button:hover {\n  background-color: #13a583;\n}\n\n\n\n\n\n\n.subtitle {\n  color: #676767;\n  font-size: 20px;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\n\n\n.logoContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  div {\n    height: 60px;\n    width: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n    background-color: #16c0981b;\n    img {\n      width: 80%;\n      height: 80%;\n      object-fit: contain;\n    }\n  }\n}\n\n.programsContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  height: 100vh;\n}\n\n@media (width <= 500px) {\n  .programsContainer {\n    height: unset;\n  }\n}\n\n.extensionsTitle {\n  font-weight: 700;\n  gap: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: #1c1e20;\n  margin-top: 0px;\n  text-align: center;\n\n  h2 {\n    margin: 0;\n    font-weight: 300;\n    font-size: clamp(\n      20px,\n      5vw,\n      40px\n    ) !important; \n  }\n}\n\n\n\n\n\n.pdfIcon {\n  height: 30px;\n  width: 30px;\n}\n\n\n.wrapper {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  text-align: center;\n  width: 88%;\n  flex-wrap: wrap; \n  align-items: center;\n  min-height: fit-content;\n}\n\n\n.card {\n  min-width: 280px;\n  max-width: 330px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px; \n  align-items: center;\n  justify-content: center;\n  h4 {\n    margin: 3px;\n    font-size: 20px;\n    font-weight: 400;\n    color: #1C1E20;\n    span{\n      font-weight: 600;\n    }\n  }\n}\n.greenWordDescription{\n  color: #10A37F;\n}\n@media (width <= 660px) {\n  .stepsContent {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.card:nth-child(3) {\n  max-width: clamp(210px, 32%, 300px); \n}\n\n.step {\n  color: #16c098 !important;\n  font-size: clamp(16px, 4vw, 22px); \n  font-weight: 400;\n  color: #18181b;\n  font-size: clamp(15px, 5vw, 19px); \n  margin: 20px 0;\n}\n\n.subtitle {\n  color: var(--_71717a-color);\n  font-size: clamp(\n    16px,\n    4vw,\n    20px\n  ); \n  font-weight: 300;\n  line-height: 1.5;\n  margin: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"packsContainer": `packsContainer_zGDGs`,
	"stepsContainer": `stepsContainer_zbiXz`,
	"stepContainer": `stepContainer_XirgO`,
	"iconContainer": `iconContainer_KftvD`,
	"steps": `steps_QCc0P`,
	"icon": `icon_nVyEx`,
	"stepsContent": `stepsContent_GrcPV`,
	"searchBar": `searchBar_HUB4S`,
	"input": `input_sSXj7`,
	"button": `button_KPlJU`,
	"subtitle": `subtitle_YEu1t`,
	"logoContainer": `logoContainer_w_Rfn`,
	"programsContainer": `programsContainer_rB63P`,
	"extensionsTitle": `extensionsTitle_kzv3L`,
	"pdfIcon": `pdfIcon_jpW70`,
	"wrapper": `wrapper_gilUt`,
	"card": `card_LqgLz`,
	"greenWordDescription": `greenWordDescription_bc16V`,
	"step": `step_kbeb_`
};
export default ___CSS_LOADER_EXPORT___;
